import { EmojiEnum } from "../../app/generated-axios-client/myModel/emoji-enum";

export const COMMENT_REACTION_EMOJIS: EmojiEnum[] = Object.values(EmojiEnum);

// U+FE0F forces emoji presentation; without it the heart renders as a plain text glyph
export const COMMENT_REACTION_GLYPHS: Record<EmojiEnum, string> = {
  [EmojiEnum.ThumbsUp]: "\u{1F44D}",
  [EmojiEnum.Check]: "✅",
  [EmojiEnum.Eyes]: "\u{1F440}",
  [EmojiEnum.Heart]: "❤️",
};
